import React from 'react';
import { messages } from 'constants/messages';
import PropTypes from 'prop-types';

export default function systemError(props) {
  return (
    <div className={`content-notfound ${props.className}`}>
      <div className="center-block">
        <img alt={messages.LOI_HE_THONG} className="bg-notdata" src={`${process.env.PUBLIC_URL}/error.png`} />
        <h3 className="heading">{messages.LOI_HE_THONG}</h3>
      </div>
    </div>
  );
}

systemError.propTypes = {
  className: PropTypes.string
};

systemError.defaultProps = {
  className: ''
};

systemError.displayName = 'SystemError';
